import homeView from './index'
import searchView from './search'
import bookView from './book'

import model from './services/model'

const routeGuard = async (to, from, next) => {
  const packageType = to.path.split('/').includes('package') ? 'package' : 'tour'
  if (model.params.packageType !== packageType || to.params.productType !== model.params.product_type) {
    model.initDataLoaded = false
    model.params.product_type = to.params.productType
    await model.init({ packageType })
  }
  next()
}

const packageViews = {
  path: 'package',
  component: homeView,
  name: 'Private/Package',
  redirect: { name: 'Private/Package/Search' },
  children: [
    {
      path: 'search',
      name: 'Private/Package/Search',
      component: searchView
    },
    {
      path: 'book/:Result/:Package/:Category/:Meal',
      name: 'Private/Package/Book',
      component: bookView
    }
  ],
  beforeEnter: routeGuard
}

const tourViews = {
  path: 'tour',
  component: homeView,
  name: 'Private/Tour',
  redirect: { name: 'Private/Tour/Search' },
  children: [
    {
      path: 'search/:productType',
      name: 'Private/Tour/Search',
      component: searchView
    },
    {
      path: 'book/:Result/:Package/:Category/:Meal/:productType',
      name: 'Private/Tour/Book',
      component: bookView
    }
  ],
  beforeEnter: routeGuard
}

export {
  packageViews,
  tourViews,
  routeGuard
}
